// src/context/SeoContext.js
// Loads admin-managed SEO config once and exposes per-page overrides + tracking.
import React, { createContext, useState, useEffect } from 'react';

const SeoContext = createContext({ seo: null, getPage: () => ({}) });

export const SeoProvider = ({ children }) => {
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    let mounted = true;
    fetch(`${process.env.REACT_APP_API_URL}/api/seo/public`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => { if (mounted && data) setSeo(data); })
      .catch(() => {});
    return () => { mounted = false; };
  }, []);

  const getPage = (path) => (seo && seo.pages && seo.pages[path]) || {};

  return (
    <SeoContext.Provider value={{ seo, getPage }}>
      {children}
    </SeoContext.Provider>
  );
};

export default SeoContext;
